import { useState } from 'react';

import { ActionIcon, Button } from '@mantine/core';
import { IconCards } from '@tabler/icons-react';

import { useChartStore } from '@/store/chartStore';

import { DeadCardModal } from './DeadCardModal';

/**
 * Dead card button that opens the dead card picker modal
 */
export function DeadCardButton() {
  const [modalOpened, setModalOpened] = useState(false);
  const deadCards = useChartStore((state) => state.deadCards);

  const hasDeadCards = deadCards.size > 0;

  const handleClick = () => setModalOpened(true);

  return (
    <>
      <ActionIcon
        variant="subtle"
        color={hasDeadCards ? 'orange' : 'gray'}
        size="lg"
        onClick={handleClick}
        aria-label="Dead cards"
        hiddenFrom="sm"
      >
        <IconCards size={18} />
      </ActionIcon>
      <Button
        variant="subtle"
        color={hasDeadCards ? 'orange' : 'gray'}
        size="compact-sm"
        onClick={handleClick}
        leftSection={<IconCards size={16} />}
        visibleFrom="sm"
      >
        Dead Cards{hasDeadCards ? ` (${deadCards.size})` : ''}
      </Button>

      <DeadCardModal opened={modalOpened} onClose={() => setModalOpened(false)} />
    </>
  );
}
